import { formatPhoneNumber } from 'utils';

angular.module('bb.my_business').component('actionRequiredDetail', {
  bindings: {},
  controller: actionRequiredDetailCtrl,
  controllerAs: 'vm',
  template: require('./action_required_detail.html'),
});

actionRequiredDetailCtrl.$inject = ['$rootScope', 'myBusinessService'];

function actionRequiredDetailCtrl($rootScope, myBusinessService) {
  const vm = this;
  vm.auth = $rootScope.auth;
  vm.tab = 'appointment';
  myBusinessService.getMyBusiness().then(function (data) {
    vm.appointments = data.appointments;
    vm.listings = data.listings.filter(
      listing => !listing.configured || listing.documentStatus === 'rejected',
    );
    vm.dataLoaded = true;
  });

  vm.formatPhoneNumber = formatPhoneNumber;

  vm.selectTab = function (requestTab) {
    vm.tab = requestTab;
  };

  vm.viewListing = function (id) {
    myBusinessService.viewListing(id);
  };

  vm.configureListing = function (id) {
    myBusinessService.configureListing(id);
  };

  vm.viewDocuments = id => {
    myBusinessService.viewDocuments(id);
  };

  vm.confirmAppointment = function (id) {
    myBusinessService.confirmAppointment(id);
  };

  vm.denyAppointment = function (id) {
    myBusinessService.denyAppointment(id);
  };

  vm.viewAppointmentDetails = function (id) {
    myBusinessService.viewAppointmentDetails(id);
  };
}

export {};
